import PropTypes from 'prop-types';

const Social = ({ value = 0 }) => (
  <svg
    width='50'
    height='21'
    viewBox='0 0 50 21'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>Social Shares</title>
    <g
      stroke='none'
      strokeWidth='1'
      fill='none'
      fillRule='evenodd'
    >
      <g id='кол-во-шеров'>
        <text
          fontFamily='Lato-Regular, Lato'
          fontSize='14'
          fontWeight='normal'
          letterSpacing='20'
          fill='#9A9EA1'
        >
          <tspan x='24' y='15'>{value}</tspan>
        </text>
        <g
          id='стрелка-шеров'
          transform='translate(0.000000, 3.000000)'
          fillRule='evenodd'
          fill='#000000'
          opacity='0.2'
        >
          <path d='M11,3.333 L11,0 L18,6.637 L11,13.333 L11,10 C11,10 4.83,9.829 0,15 C2.269,5.119 11,3.333 11,3.333 Z' />
        </g>
      </g>
    </g>
  </svg>
);

Social.propTypes = {
  value: PropTypes.number,
};

export default Social;
